<template>
  <div class="grid-container">
    <template v-for="gridLevel in levels" :key="`grid-level-${gridLevel}`">
      <div
        :class="
          'level ' +
          (level === gridLevel
            ? 'active'
            : gridLevel > level
            ? 'disabled'
            : 'default')
        "
        @click="onClick(gridLevel)"
      >
        {{ `x${gridLevel}` }}
      </div>
    </template>
  </div>
</template>

<script setup>
  import { computed, ref } from 'vue';

  const emit = defineEmits(['update']);

  const levels = ref([1, 2, 3, 4, 5]);

  const props = defineProps({
    parentLevel: {
      type: Number,
      required: true,
    },
  });

  const level = computed(() => {
    return props.parentLevel <= 5 ? props.parentLevel + 1 : props.parentLevel;
  });

  const onClick = (newLevel) => {
    console.log(
      `onClick: level=${level.value}, newLevel=${newLevel}, newParentLevel=${
        newLevel - 1
      }`
    );
    if (newLevel < level.value) {
      emit('update', newLevel - 1);
    }
  };
</script>

<style scoped lang="scss">
@use "@/assets/styles/_colors.scss" as *;

  .grid-container {
    background: $color-bg-primary-white;
    border-radius: 7px;
    display: grid;
    grid-gap: 16px;
    padding: 6px;

    .level {
      border-radius: 4px;
      font-family: Nunito Sans, sans-serif;
      font-weight: 800;
      font-size: 16px;
      line-height: 22px;
      text-align: center;

      &.default {
        background: $color-bg-primary-white;
        color: $color-tag;
      }

      &.active {
        background: $color-bg-status-done;
        color: $color-text-secondary-white;
      }

      &.disabled {
        background: $color-bg-primary-white;
        color: $color-text-secondary-grey;
      }
    }
  }
</style>
